<h2>Secure Messages</h2>
<div class="panelbar-wrapper secure-messages nova-font-style">
  <div>
    <div id="secure-messages" class="controlsBar">
      <div *ngIf="messageCount > 1">
        <legend class="legend-heading">
          <span class="bold">Unread Messages </span>
          <span class="number-badge" [ngClass]="setPaddingClass()">
            <app-message-count [msgCount]="messageCount" [fromDetails]="'secu-messages'">
            </app-message-count>
          </span>
        </legend>
      </div>
      <div class="row background-tan search-row bottom-margin-0">
        <div class="col s12 m3 l3 align-left padding-5">
          <button id="composeBtn" class="btn waves-effect full-width" (click)="compose()">
            <span class="k-icon k-i-edit k-i-pencil height-auto"></span>Compose
          </button>
        </div>
        <div class="col s12 m3 l3 align-left padding-5 ">
          <button id="deleteBtn" [disabled]="deleteDisabled" class="btn waves-effect full-width" (click)="delete()">
            <span class="k-icon k-i-trash height-auto"></span>Archive
          </button>
        </div>
        <div class="col s12 m3 l3 align-center right-padding-0 left-padding-0 top-padding-5 msg-dropdown">
          <kendo-dropdownlist [popupSettings]="{ popupClass: 'nova-font-style font-size-16 text-black' }"
            [data]="listItems" [(ngModel)]="selectedValue" [valuePrimitive]="true" (valueChange)="changeMenu($event)">
          </kendo-dropdownlist>
        </div>
        <div class="col s12 m3 l3 align-left top-padding-5 left-padding-5">
          <div class="input-field full-width search-input">
            <input class="background-white search-box" (keyup)="searchGrid($event)" #search type="search" required
              placeholder="Search">
          </div>
        </div>
      </div>
      <!-- delete message -->
      <kendo-dialog title="Please confirm" *ngIf="opened" (close)="close()" [minWidth]="250" [maxWidth]="450"
        class="messages-dialog">
        <p class="dialog-heading">Are you sure you want to delete these records?</p>
        <div class="row margin-bottom-0 row-border-top">
          <div class="col s12 m12 l12">
            <div class="col s12 m6 l6 align-center">
              <button id="no-btn" class="logout dialog-button" (click)="close()">No</button>
            </div>
            <div class="col s12 m6 l6 align-center">
              <button id="yes-btn" class="logout dialog-button" (click)="deleteMessage()" primary="true">Yes</button>
            </div>
          </div>
        </div>
      </kendo-dialog>
      <!-- compose message -->
      <kendo-dialog title="Compose Message" *ngIf="composeMessage" [minWidth]="250" [maxWidth]="650"
        class="dialog-comments messages-dialog" (close)="close()">
        <app-compose-message [inputData]="inputData" (closeModel)="closeDialog()"></app-compose-message>
      </kendo-dialog>
      <!-- view message -->
      <kendo-dialog title="View Message" *ngIf="openMessage" [minWidth]="330" [maxWidth]="650"
        class="dialog-comments messages-dialog" (close)="close()">
        <app-view-message [inputData]="inputData" (closeModel)="closeDialog()" (updateGrid)="updateGrid()"
          [msgData]="msgData">
        </app-view-message>
      </kendo-dialog>
      <div *ngIf="gridLoading" class="k-i-loading"></div>
      <div class="row background-tan height-auto">
        <kendo-grid #grid [data]="gridData" [pageSize]="pageSize" [skip]="skip" [sort]="sort" [sortable]="true"
          [navigable]="true" [showOperators]="false" [pageable]="true" [filterable]="false"
          [selectable]="selectableSettings" (pageChange)="pageChange($event)" (selectionChange)="clickedPage($event)"
          (sortChange)="sortChange($event)" id="message-grid">
          <kendo-grid-checkbox-column *ngIf="selectedValue !== 'Archived Messages'" class="chkbox kendo-checkbox"
            [width]="40">
            <ng-template kendoGridCellTemplate let-idx="rowIndex" let-dataItem>
              <div class="align-center">
                <input [kendoGridSelectionCheckbox]="idx" class="k-checkbox" type="checkbox" id="{{'chk'+idx}}" />
                <label class="k-checkbox-label" for="{{'chk'+idx}}"></label>
              </div>
            </ng-template>
          </kendo-grid-checkbox-column>
          <!-- Mobile View -->
          <kendo-grid-column media="(max-width: 599.98px)" title="Details">
            <ng-template kendoGridCellTemplate let-dataItem>
              <dl>
                <dt>
                </dt>
                <dd>
                  <div class="align-left">
                    <span class="bold">Message Subject</span>:
                    <span class="clone-link" (click)="viewMessage(dataItem)">
                      <span [ngClass]="!dataItem.read ? 'bold' : ''">{{dataItem.subject}}</span>
                    </span>
                  </div>
                </dd>
                <dt>
                </dt>
                <dd>
                  <div class="align-left">
                    <span class="bold">Message Topic</span>:
                    <span>{{dataItem.topic}}</span>
                  </div>
                </dd>
                <dt>
                </dt>
                <dd>
                  <div class="align-left" *ngIf="!sentMessage">
                    <span class="bold">Received Date Time</span>:
                    <span>{{dataItem.receivedDt | date:'MM/dd/yyyy hh:mm a'}}</span>
                  </div>
                </dd>
                <dt>
                </dt>
                <dd>
                  <div class="align-left" *ngIf="sentMessage">
                    <span class="bold">Sent Date Time</span>:
                    <span>{{dataItem.sendDt | date:'MM/dd/yyyy hh:mm a'}}</span>
                  </div>
                </dd>
              </dl>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column media="(min-width: 600px)" field="subject" title="Message Subject" [width]="170">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="align-left">
                <div class="clone-link" (click)="viewMessage(dataItem)">
                  <span [ngClass]="!dataItem.read ? 'bold' : ''">{{dataItem.subject}}</span>
                </div>
              </div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column media="(min-width: 600px)" field="topic" title="Message Topic" [width]="170">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="align-left">{{dataItem.topic}}</div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column media="(min-width: 600px)" field="receivedDt" title="Received Date Time" [width]="140"
            *ngIf="!sentMessage" [headerClass]="{'align-date': true}">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="align-center">{{dataItem.receivedDt | date:'MM/dd/yyyy hh:mm a'}}</div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column media="(min-width: 600px)" field="sendDt" title="Sent Date Time" [width]="140"
            *ngIf="sentMessage" [headerClass]="{'align-date': true}">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="align-center">{{dataItem.sendDt | date:'MM/dd/yyyy hh:mm a'}}</div>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </div>
      <div class="scroll-text text-red" *ngIf="messageCount > 0">
        <span [innerHTML]="scrollMessage"></span>
      </div>
    </div>
  </div>
</div>
<app-notification-loading></app-notification-loading>